import React from 'react';
import { C, WHATSAPP_URL } from '../theme';

export default function WhatsAppFloat() {
  return (
    <a
      className="cn-wa-float"
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with CarelyNest on WhatsApp"
      style={{
        position: 'fixed', right: 22, bottom: 22, zIndex: 80,
        width: 60, height: 60, borderRadius: '50%', background: C.waGreen,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        boxShadow: '0 12px 26px -8px rgba(37,145,89,.6)', animation: 'cnpulse 2.6s infinite',
      }}
    >
      <svg viewBox="0 0 32 32" width="32" height="32" fill="#fff" aria-hidden="true">
        <path d="M16.04 4C9.9 4 4.9 9 4.9 15.14c0 2.17.62 4.19 1.7 5.9L4.5 28l7.14-2.06a11.1 11.1 0 0 0 4.4.9h.01c6.14 0 11.14-5 11.14-11.14C27.19 9 22.19 4 16.04 4zm0 20.4h-.01a9.2 9.2 0 0 1-4.7-1.29l-.34-.2-3.97 1.15 1.16-3.87-.22-.35a9.16 9.16 0 0 1-1.4-4.9c0-5.09 4.14-9.23 9.24-9.23 2.47 0 4.79.96 6.53 2.71a9.16 9.16 0 0 1 2.7 6.53c0 5.09-4.14 9.24-9.24 9.24zm5.07-6.92c-.28-.14-1.64-.81-1.9-.9-.25-.09-.44-.14-.62.14-.18.28-.71.9-.87 1.08-.16.18-.32.2-.6.07-.28-.14-1.17-.43-2.23-1.38-.83-.73-1.38-1.64-1.55-1.92-.16-.28-.02-.43.12-.57.13-.13.28-.32.42-.48.14-.16.18-.28.28-.46.09-.18.05-.35-.02-.49-.07-.14-.62-1.5-.85-2.05-.22-.54-.45-.47-.62-.48l-.53-.01c-.18 0-.48.07-.73.35-.25.28-.96.94-.96 2.3 0 1.35.98 2.66 1.12 2.84.14.18 1.93 2.95 4.68 4.13.65.28 1.16.45 1.56.58.66.21 1.25.18 1.72.11.53-.08 1.64-.67 1.87-1.32.23-.65.23-1.2.16-1.32-.07-.12-.25-.19-.53-.33z" />
      </svg>
    </a>
  );
}
